module.exports = __webpack_public_path__ + "img/bg-dashboard-plan.e7672cad.jpg";